export const MainMenu = [
  {
    name: 'Loans',
    id: 'personal-loan',
    subMenu: [
      {
        name: 'Personal Loans',
        urlPath: '/personal/?icid=wp-menu-loan-pl',
      },
      {
        name: 'Debt Consolidation Loans',
        urlPath: '/debt-consolidation/?icid=wp-menu-loan-dc',
      },
      {
        name: 'Loans for Bad Credit',
        urlPath: '/personal/best-personal-loans-for-bad-credit/?icid=wp-menu-loan-badcredit',
      },
      {
        name: 'Auto Loans',
        urlPath: '/auto/?icid=wp-menu-loan-auto',
      },
      {
        name: 'Auto Loan Refinance',
        urlPath: '/auto/refinance/?icid=wp-menu-auto-refi',
      },
    ],
  },
  {
    name: 'Business',
    id: 'business-loan',
    subMenu: [
      {
        name: 'Business Loans',
        urlPath: '/business/small/?icid=wp-menu-biz-smb',
      },
      {
        name: 'Business Line of Credit',
        urlPath: '/business/line-of-credit/?icid=wp-menu-biz-loc',
      },
      {
        name: 'Working Capital Loans',
        urlPath: '/business/working-capital/?icid=wp-menu-biz-wc',
      },
      {
        name: 'Startup Business Loans',
        urlPath: '/business/how-to-get-a-startup-business-loan/?icid=wp-menu-biz-startup',
      },
    ],
  },
  {
    name: 'Mortgages',
    id: 'mortgage',
    subMenu: [
      {
        name: 'Mortgage Rates',
        urlPath: '/home/mortgage/rates/?icid=wp-menu-home-mtg',
      },
      {
        name: 'Home Equity Loan Rates',
        urlPath: '/home/home-equity/?icid=wp-menu-home-he',
      },
      {
        name: 'HELOC Rates',
        urlPath: '/home/home-equity/heloc/?icid=wp-menu-home-heloc',
      },
      {
        name: 'Refinance Rates',
        urlPath: '/home/refinance/?icid=wp-menu-home-refi',
      },
      {
        name: 'Cash out Refinance',
        urlPath: '/home/refinance/cash-out/?icid=wp-menu-home-corefi',
      },
    ],
  },
  {
    name: 'Credit Cards',
    id: 'credit-cards',
    subMenu: [
      {
        name: 'Best Credit Cards',
        urlPath: '/credit-cards/?icid=wp-menu-cc-cc',
      },
      {
        name: 'Balance Transfer Credit Cards',
        urlPath: '/credit-cards/best/balance-transfer/?icid=wp-menu-cc-bt',
      },
      {
        name: 'Cash Back Credit Cards',
        urlPath: '/credit-cards/best/cashback-credit-cards/?icid=wp-menu-cc-cb',
      },
      {
        name: 'Credit Cards for Bad Credit',
        urlPath: '/credit-cards/best/bad-credit/?icid=wp-menu-cc-bc',
      },
    ],
  },
  {
    name: 'Insurance',
    id: 'insurance',
    subMenu: [
      {
        name: 'Car Insurance',
        urlPath: '/car-insurance/?icid=wp-menu-ins-car',
      },
      {
        name: 'Home Insurance',
        urlPath: '/home-insurance/?icid=wp-menu-ins-home',
      },
      {
        name: 'Renters Insurance',
        urlPath: '/renters-insurance/?icid=wp-menu-ins-rent',
      },
    ],
  },
] as const;

export function getPersonalMenuItems() {
  return [
    {
      name: 'Homebase',
      urlPath: `${REPLACE_MY_LT_URL}/homebase?icid=cw-menu-dash`,
    },
    {
      name: 'Manage Profile',
      urlPath: `${REPLACE_MY_LT_URL}/profile?icid=cw-menu-profile`,
    },
    {
      name: 'Credit Report',
      urlPath: `${REPLACE_MY_LT_URL}/credit-report?icid=cw-menu-cr`,
    },
    {
      name: 'Confirm Accounts',
      urlPath: `${REPLACE_MY_LT_URL}/confirm-accounts?icid=cw-menu-confirm`,
    },
    {
      name: 'Dispute Center',
      urlPath: `${REPLACE_MY_LT_URL}/dispute-center?icid=cw-menu-dispute`,
    },
    {
      name: 'Change Password',
      urlPath: `${REPLACE_AUTH_API}/account/ResetPassword?returnUrl=${encodeURIComponent(location.href)}&icid=cw-menu-pw&isChangePassword=true`,
    },
    {
      name: 'Subscription Center',
      urlPath: `${REPLACE_SUBS_URL}/account/manage?icid=cw-menu-sub`,
    },
    {
      name: 'Sign Out',
      urlPath: `${REPLACE_LT_WWW_URL}/account/logoff?icid=cw-menu-signout`,
    },
  ];
}
